import { Intangible } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

import { TourViewModel } from '@api/v3';
import { ListingMetaViewModel } from '@components/views/types';

export const TourListSchemaOrg = ({
  tour,
  destination,
}: {
  tour: TourViewModel[][];
  destination: ListingMetaViewModel;
}) => {
  return (
    <Script
      defer
      {...jsonLdScriptProps<Intangible>({
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: destination.title,
        itemListElement: tour?.[0]?.map((item, index) => ({
          '@type': 'ListItem',
          position: index,
          name: item.name, //tour program name
          description: item.placesToGo,
          url: `${process.env.NEXT_PUBLIC_HOST}/${item.url}`,
        })),
      })}
    />
  );
};
